<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1s demo-form-inline" ref="query" :model="query" size="small">
      	  <el-form-item style="width:19%">
		        <el-date-picker
		            v-model="query.date"
		            type="daterange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd" @change="isselect=true" clearable style="width:100%">
		        </el-date-picker>
	        </el-form-item>
          <!-- 活动状态 -->

          <!-- 关键字搜索类型 -->
          <el-form-item style="width:17%">
          	  <el-select v-model="query.keytype" filterable>
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in keytypelists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 关键字 -->
          <el-form-item>
              <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="danger" icon="el-icon-circle-plus-outline" @click="addoffers">添加活动</el-button>
              <!--
              <el-button type="primary" icon="el-icon-search" @click="getList">导出</el-button>
              -->
          </el-form-item>
      </el-form>

      <!-- 活动信息小计 -->
      <div class="backborder2" style="margin-top:10px;padding:3px 1% 30px 1%;background:none;border:none">
        <div style="float:left;width:100%">
            <el-tooltip class="item" effect="dark" content="包含活动商品的商城订单数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单次数小计：{{stattotals.orders}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含活动商品的店铺数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单店铺数小计：{{stattotals.shops}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含活动商品的人数小计（已付款的订单）" placement="top">
                <span class="activetotal">下单人数小计：{{stattotals.users}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="活动商品在商城所下的订单里实际付款的金额小计（已付款的订单）" placement="top">
                <span class="activetotal">实付金额小计：{{stattotals.amounts}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="活动商品在商城所下的订单里的成本小计（已付款的订单）" placement="top">
                <span class="activetotal">成本小计：{{stattotals.costs}}</span>
            </el-tooltip>
        </div>
      </div>
      <!------------------------search end---------------------->

      <!-- 温馨提示 -->
      <div :class="iswarningclose ? 'backborder2s' : 'backborder2s closenotice' " style="margin-top:10px;padding:3px 1% 10px 1%">
        <div class="content">
          <ul>
            <li>1、商品数量：分母显示的是当前活动所添加的商品种数，分子显示的是已成交的订单里所包含的商品种数</li>
            <li>2、成交订单数：线上商城已支付的订单数（只统计包含当前活动商品的订单）</li>
            <li>3、下单店铺数：购买活动商品的店铺数量</li>
            <li>4、实付金额：线上商城所下的订单里包含活动的商品的实付金额（由订单的实付金额按订单商品的金额比例换算）</li>
            <li>5、成本：线上商城所下的订单里包含活动的商品的成本</li>
          </ul>
        </div>
        <div class="close">
          <el-button @click="closenotice" type="danger" icon="el-icon-close" size="mini" circle></el-button>
        </div>
      </div>
	  
	  <!------------------------活动信息列表----------------------->
	  <div class="backborder2 backbbtn" style="margin-top:10px">
	      <el-table :data="datalists" v-loading="listLoading">
            <el-table-column prop="id" label="id" width="50" align="center"></el-table-column>
	          <el-table-column label="活动信息">
              <template slot-scope="scope">
                <div style="float:left;width:100%" class="offertitles">
                    <span>{{scope.row.name}}</span>
                    <i class="offerstatus1" v-if="scope.row.status==1">未开始</i>
                    <i class="offerstatus2" v-if="scope.row.status==2">进行中</i>
                    <i class="offerstatus1" v-if="scope.row.status==3">已结束</i>
                </div>
                <div style="float:left;width:100%" class="offermoney"><i>价格阀值</i><span>{{scope.row.limitpercent}}%</span></div>
                <div style="float:left;width:100%" class="offermoney"><i>创建人员</i><span>{{scope.row.managername}}</span></div>
                <div style="float:left;width:100%" class="offertime"><i>创建时间</i><span>{{scope.row.time}}</span></div>
              </template>
            </el-table-column>
            <el-table-column prop="goods" label="商品数量" width="110" align="center"></el-table-column>
            <el-table-column prop="orders" label="成交订单数" width="110" align="center"></el-table-column>
            <el-table-column prop="shops" label="下单店铺数" width="110" align="center"></el-table-column>
            <el-table-column prop="users" label="下单人数" width="110" align="center"></el-table-column>
            <el-table-column prop="realamount" label="实付金额" width="110" align="center"></el-table-column>
            <el-table-column prop="cost" label="成本" width="110" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="活动详情" placement="top">
                      <el-button type="primary" icon="el-icon-document" size="mini" circle @click="showactives(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="编辑活动" placement="top">
                      <el-button type="warning" icon="el-icon-edit" size="mini" circle  @click="editoffersnew(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="活动商品下单统计" placement="top">
                      <el-button type="warning" icon="el-icon-goods" size="mini" circle @click="getorderstats(scope.row)"></el-button>
                  </el-tooltip>
                  <!--
                  <el-tooltip class="item" effect="dark" content="修改记录" placement="top">
                      <el-button type="warning" icon="el-icon-edit-outline" size="mini" circle></el-button>
                  </el-tooltip>
                  -->
                  <el-tooltip class="item" effect="dark" content="删除活动" placement="top">
                      <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deloffersnew(scope.row)"></el-button>
                  </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
		      <!--分页begin-->
		      <el-pagination 
              @size-change="pageSizeChange" 
              @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
    </div>


    <!-- 新增活动模块 start -->
    <el-dialog title="新增 / 编辑活动" :visible.sync="addactiveDialog" width="70%" top="10vh" :before-close="closeadd">
        <el-form class="addoffersnew">
          <el-form-item label="活动图片" label-width="110px">
              <template>
                  <div class="backborder-other" style="overflow:hidden;position:relative">
                      <ul class="imglists">
                          <li v-for="(item,index) in addActivequery.thumb" :key="index">
                              <img :src="GLOBAL.staticUrl+item" />
                              <a @click="closethumb(index)" class="thumbclose">-</a>
                          </li>
                          <li>
                              <input type="file" id="adimg" style="display:none" @change="getadimgb($event)"/>
                              <a @click="getadimga()"><img src="../../static/images/no-img.png" /></a>
                          </li>
                      </ul>
                  </div>
              </template>
          </el-form-item>
          <el-form-item label="活动名称" label-width="110px">
              <el-input v-model="addActivequery.name" size="small" style="width:40%"></el-input>
          </el-form-item>
          <el-form-item label="活动时间" label-width="100px">
		        <el-date-picker
                size="small"
		            v-model="addActivequery.date"
		            type="datetimerange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd HH" clearable style="width:50%">
		        </el-date-picker>
	        </el-form-item>
          <el-form-item label="价格阀值" label-width="110px">
              <el-input v-model="addActivequery.limitpercent" size="small" style="width:20%"><template slot="append">%</template></el-input>
              <el-tag type="danger" size="mini">注：当活动商品的秒杀价 < （商品正常价-商品正常价*阀值%100）时，商品将不可下单，显示为已售罄，主要用于京东商品</el-tag>
          </el-form-item>
          <el-form-item label="详情设置" label-width="110px">
		        <template slot-scope="scope">
                <el-button size="small" type="primary" round style="float:left;" @click="addcontentDialog=true">详情设置</el-button>
                <el-button size="small" type="primary" round style="float:left;" @click="addshareDialog=true">分享设置</el-button>
            </template>
	        </el-form-item>
          <el-form-item label="活动商品" label-width="110px">
              <template slot-scope="scope">
                <el-button size="small" type="danger" round style="float:left;" @click="checkgoods">新增商品</el-button>
                <div class="offersallsetting">
                  <p>已选 <em>{{addActivequery.goods.length}}</em> 个商品</p>
                </div>
                <el-button size="small" type="danger" round style="float:left;margin-left:2%" @click="deladdoffersall">清空已选商品</el-button>
              </template>
          </el-form-item>
        </el-form>
        <div class="offersnewgoods">
          <el-table :data="addActivequery.goods" v-loading="addActivequeryloading">
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.name}}</div>
                <div class="showoffersgoodsspec"><a @click="changeproperty(scope.row,scope.$index)">规格：{{scope.row.spec}}</a></div>
                <i style="float:left;width:100%;font-style:normal;font-size:12px;line-height:25px;color:#999999">重量：{{scope.row.weight}} kg</i>
                <i class="showoffersgoodsagent">{{scope.row.agentname}}</i>
                <i :class="scope.row.type==1 ? 'showoffersgoodscz' : 'showoffersgoodsjd' ">{{scope.row.type==1 ? '宠赞商品' : '京东商品'}}</i>
              </template>
            </el-table-column>
            <el-table-column label="秒杀价格" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.price" size="small" style="width:70%"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品数量" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.allnums" size="small" style="width:70%"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="每人限购数量" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.limitnums" size="small" style="width:70%"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="起送数量" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.sendnums" size="small" style="width:70%"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deladdoffersgoods(scope.$index)"></el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addactiveDialog=false">取 消</el-button>
            <el-button size="small" type="primary" :loading="addoffersnewLoading" @click="addcreateSave">保存</el-button>
        </div>  
    </el-dialog>

    <!-- 活动详情信息设置 -->
    <el-dialog title="活动详情" :visible.sync="addcontentDialog" width="50%" top="10vh">
        <div style="display:none"><input type="file" class="addoffersfile" @change="getaddimg($event)"></div>
        <quill-editor v-model="addActivequery.content"
            ref="myQuillEditor"
			      :options="editorOption"
			      @onEditorChange="onEditorchange($event)">
  			</quill-editor>
    </el-dialog>
    <!-- 新增活动模块 end -->

    <!-- 选择商品信息设置 -->
    <el-dialog title="选择商品信息" :visible.sync="goodsDialog" width="60%" top="10vh">
        <div style="float:left;width:100%;text-align:right;margin-bottom:10px">
            <el-button size="small" @click="goodsDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="addgoodssave">保存</el-button>
        </div>  
        <el-form :inline="true">
          <el-form-item style="width:20%" v-if="saleagents.length > 1">
      		  <el-select v-model="goodsquery.parentagentid" size="small" filterable clearable @change="goodsqueryischange=true" placeholder="请选择商品来源">
	              <el-option v-for="(item,index) in saleagents" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
      	  </el-form-item>
          <el-form-item style="width:15%">
      		  <el-select v-model="goodsquery.isgrounding" size="small" filterable clearable @change="goodsqueryischange=true">
	              <el-option v-for="(item,index) in groundings" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
      	  </el-form-item>
          <el-form-item style="width:15%" v-if="isjdshow==true">
      		  <el-select v-model="goodsquery.type" size="small" filterable clearable @change="goodsqueryischange=true">
	              <el-option v-for="(item,index) in datafrom" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
      	  </el-form-item>
          <el-form-item style="width:18%">
          	  <el-select v-model="goodsquery.brandid" clearable remote  filterable placeholder="按品牌" @change="goodsqueryischange=true" size="small">	            
                  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  </el-option>              
              </el-select>          
          </el-form-item>
          <el-form-item>
              <el-input placeholder="请输入商品名称 / 规格名称" size="small" v-model="goodsquery.key" clearable @keyup.enter.native="getgoodsList" @change="goodsqueryischange=true" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
					    <el-button size="small" type="primary" icon="el-icon-search" circle @click="getgoodsList"></el-button>
				  </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="goodslists" v-loading="goodslistsloading" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall">
            <el-table-column type="selection" width="50"></el-table-column>
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.name}}</div>
                <div class="showoffersgoodsspec">规格：{{scope.row.spec}}，（id：{{scope.row.propertyid}}）</div>
                <div class="showoffersgoodsspec">重量：{{scope.row.weight}} kg</div>
                <i class="showoffersgoodsagent">{{scope.row.agentname}}</i>
                <i :class="scope.row.type==0 ? 'showoffersgoodscz' : 'showoffersgoodsjd' ">{{scope.row.type==0 ? '宠赞商品' : '京东商品'}}</i>
              </template>
            </el-table-column>
            <el-table-column label="价格" prop="price" width="110" align="center"></el-table-column>
            <el-table-column label="是否已上架" width="110" align="center">
              <template slot-scope="scope">
                <span style="color:#F56C6C" v-if="scope.row.isgrounding==1">未上架</span>
                <span style="color:#67C23A" v-if="scope.row.isgrounding==0">已上架</span>
              </template>
            </el-table-column>
            <el-table-column label="品牌" prop="brandname" width="170" align="center"></el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChoosegoodsChange"
            @current-change="pageChoosegoodsCurrentChange"
            :current-page="goodsquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="goodsquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="goods_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="goodsDialog=false">取 消</el-button>
            <el-button size="small" type="primary" @click="addgoodssave">保存</el-button>
        </div>  
    </el-dialog>
    <!-- 选择商品信息设置 end -->

    <!-- 选择商品规格信息设置 start -->
    <el-dialog title="选择商品规格信息" :visible.sync="propertyDialog" width="50%" top="10vh">
        <el-table :data="propertylists" v-loading="propertyloading">
            <el-table-column label="id" prop="id" width="90" align="center"></el-table-column>
            <el-table-column label="规格名称" prop="spec"></el-table-column>
            <el-table-column label="价格" prop="price" width="110" align="center"></el-table-column>
            <el-table-column label="重量（kg）" prop="weight" width="110" align="center"></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-check" size="mini" circle @click="selectpropertys(scope.row)"></el-button>
              </template>
            </el-table-column>
        </el-table>
    </el-dialog>
    <!-- 选择商品规格信息设置 end -->

    <!-- 活动信息详情 start-->
    <el-dialog title="活动详情信息" :visible.sync="showoffersDialog" width="85%" top="10vh">
        <div v-loading="showoffersloaing" style="float:left;width:100%;margin-bottom:20px">
          <el-col :span="24" style="margin-bottom:10px">
              <div class="backborder-other" style="overflow:hidden;position:relative">
                  <ul class="imglists">
                      <li v-for="(item,index) in showoffersinfos.thumb" :key="index">
                          <img :src="GLOBAL.staticUrl+item" />
                      </li>
                  </ul>
              </div>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">活动名称：{{showoffersinfos.name}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">价格阀值：<i style="font-style:normal;color:#8b572a;font-weight:bold;font-size:14px">{{showoffersinfos.limitpercent}}%</i></el-col>
          <el-col :span="24" style="margin-bottom:10px">
              <div style="float:left;width:100%" class="offertitles">
                  <span>活动时间：{{showoffersinfos.time}}</span>
                  <i class="offerstatus1" v-if="showoffersinfos.status==1">未开始</i>
                  <i class="offerstatus2" v-if="showoffersinfos.status==2">进行中</i>
                  <i class="offerstatus1" v-if="showoffersinfos.status==3">已结束</i>
              </div>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">添加时间：{{showoffersinfos.inputtime}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">创建账号：{{showoffersinfos.managername}}</el-col>
          <el-col :span="24" style="margin-bottom:10px">活动详情：
              <el-button type="primary" size="mini" round @click="offersnewDialog=true">活动详情信息</el-button>
              <el-button type="primary" size="mini" round @click="sharedetailnewDialog=true">分享详情信息</el-button>
          </el-col>
        </div>
        <el-table :data="showoffersinfos.goods">
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.goodsname}}</div>
                <div class="showoffersgoodsspec">规格：{{scope.row.propertyname}}</div>
                <div class="showoffersgoodsspec">重量：{{scope.row.weight}} kg</div>
                <i class="showoffersgoodsagent">{{scope.row.agentname}}</i>
                <i :class="scope.row.goodstype==1 ? 'showoffersgoodscz' : 'showoffersgoodsjd' ">{{scope.row.goodstype==1 ? '宠赞商品' : '京东商品'}}</i>
              </template>
            </el-table-column>
            <el-table-column label="是否上架" align="center">
              <template slot-scope="scope">
                  <span style="color:#F56C6C" v-if="scope.row.isgrounding==1">未上架</span>
                  <span style="color:#67C23A" v-if="scope.row.isgrounding==0">已上架</span>
              </template>
            </el-table-column>
            <el-table-column label="品牌" prop="brandname" width="120" align="left"></el-table-column>
            <el-table-column label="秒杀价" prop="price" width="120" align="center"></el-table-column>
            <el-table-column label="商品总数量" prop="allnums" width="120" align="center"></el-table-column>
            <el-table-column label="每人限购数量" prop="g_limit_nums" width="120" align="center"></el-table-column>
            <el-table-column label="起送数量" prop="sendnums" width="120" align="center"></el-table-column>
            <el-table-column label="已购买数量" prop="costnums" width="120" align="center"></el-table-column>
        </el-table>
    </el-dialog>
    <!-- 活动信息详情 end -->

    <!-- 活动详情信息 start -->
    <el-dialog title="活动详情信息" :visible.sync="offersnewDialog" width="50%" top="10vh">
      <div class="offersnewct" style="float:left;width:100%" v-html="showoffersinfos.content"></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="offersnewDialog=false">取 消</el-button>
      </div>  
    </el-dialog>
    <!-- 活动详情信息 end -->

    <!-- 活动商品信息及下单情况 -->
    <el-dialog title="活动商品信息统计" :visible.sync="offersgoodsstatDialog" width="90%" top="10vh">
       <el-table :data="offersnewsgoods" v-loading="offersgoodsstatloading">
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.goodsname}}</div>
                <div class="showoffersgoodsspec">规格：{{scope.row.propertyname}}</div>
                <div class="showoffersgoodsspec">重量：{{scope.row.weight}} kg</div>
                <i class="showoffersgoodsagent">{{scope.row.agentname}}</i>
                <i :class="scope.row.goodstype==1 ? 'showoffersgoodscz' : 'showoffersgoodsjd' ">{{scope.row.goodstype==1 ? '宠赞商品' : '京东商品'}}</i>
              </template>
            </el-table-column>
            <el-table-column label="品牌" prop="brandname" width="100" align="left"></el-table-column>
            <el-table-column label="商品总数量" prop="allnums" width="100" align="center"></el-table-column>
            <el-table-column label="已购买数量" prop="costnums" width="100" align="center"></el-table-column>
            <el-table-column label="下单次数" prop="orders" width="100" align="center"></el-table-column>
            <el-table-column label="下单店铺数" prop="shops" width="100" align="center"></el-table-column>
            <el-table-column label="下单人数" prop="users" width="100" align="center"></el-table-column>
            <el-table-column label="实付金额" prop="totals" width="100" align="center"></el-table-column>
            <el-table-column label="成本" prop="costs" width="100" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" circle icon="el-icon-search" @click="showgoodsorders(scope.row)"></el-button>
              </template>
            </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 活动商品信息及下单情况 -->

    <!-- 活动商品信息订单详情 -->
    <el-dialog title="订单信息详情" :visible.sync="showgoodsordersDialog" width="95%" top="10vh">
       <el-table :data="showgoodsorderslists" v-loading="showgoodsordersloading">
	          <el-table-column label="订单信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.sn}}</div>
                <div class="showoffersgoodsspec">下单店铺：{{scope.row.shopname}}</div>
                <div class="showoffersgoodsspec">下单城市：{{scope.row.city}}</div>
                <div class="showoffersgoodsspec">详细地址：{{scope.row.address}}</div>
              </template>
            </el-table-column>
            <el-table-column label="收货人" prop="truename" width="100" align="center"></el-table-column>
            <el-table-column label="收货电话" prop="phone" width="120" align="center"></el-table-column>
            <el-table-column label="单价" prop="price" width="100" align="center"></el-table-column>
            <el-table-column label="数量" prop="numbers" width="100" align="center"></el-table-column>
            <el-table-column label="实付小计" prop="totals" width="100" align="center"></el-table-column>
            <el-table-column label="成本" prop="costs" width="100" align="center"></el-table-column>
            <el-table-column label="付款时间" prop="pay_time" width="150" align="center"></el-table-column>
            <el-table-column label="发货单号" prop="sendsn" width="130" align="center"></el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageoffersordersChange"
            @current-change="pageoffersordersCurrentChange"
            :current-page="showgoodsordersquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="showgoodsordersquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="showgoodsorders_row">
          </el-pagination>
          <!--分页end-->
        </div>
    </el-dialog>
    <!-- 活动商品信息订单详情 -->

    <!-- 分享设置 start-->
    <el-dialog title="活动分享信息设置" :visible.sync="addshareDialog" width="50%" top="10vh">
        <el-tag type="danger" size="min">温馨提示：请按照相关分享平台的规则来设置分享内容、字数、图片大小，以免分享后无法查看到设置内容</el-tag>
        <el-form :inline="true" style="margin-top:10px">
            <el-form-item label="分享图片" label-width="100" size="small" style="width:100%;">
                <template>
                  <div style="float:left;width:100px;border:1px dashed #ddd;border-radius:12px">
                    <input type="file" id="shareimg" style="display:none" @change="getshareaddimg($event)">
                    <a style="float:left;width:100%;cursor:pointer" @click="getsharecontent">
                      <img :src="GLOBAL.staticUrl+addActivequery.share.img" v-if="addActivequery.share.img!=''" style="float:left;width:100%;border-radius:12px"/>
                      <img src="../../static/images/no-img.png" v-if="addActivequery.share.img==''" style="float:left;width:100%;border-radius:12px"/>
                    </a>
                  </div>
                </template>
      	    </el-form-item>
            <el-form-item label="分享标题" label-width="100" size="small" style="width:100%;">
                <el-input placeholder="请输入分享标题" v-model="addActivequery.share.title" clearable style="width:400px"></el-input>
      	    </el-form-item>
            <el-form-item label="分享内容" label-width="100" style="width:100%;">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10}" placeholder="请输入分享内容" v-model="addActivequery.share.content" style="width:400px" clearable></el-input>
      	    </el-form-item>
        </el-form>
    </el-dialog>


    <el-dialog title="活动分享信息" :visible.sync="sharedetailnewDialog" width="50%" top="10vh">
        <el-form :inline="true" style="margin-top:10px">
            <el-form-item label="分享图片" label-width="100" size="small" style="width:100%;">
                <template>
                  <div style="float:left;width:100px;border:1px dashed #ddd;border-radius:12px">
                      <img :src="GLOBAL.staticUrl+showoffersinfos.shareimg" v-if="showoffersinfos.shareimg!=''" style="float:left;width:100%;border-radius:12px"/>
                      <img src="../../static/images/no-img.png" v-if="showoffersinfos.shareimg==''" style="float:left;width:100%;border-radius:12px"/>
                  </div>
                </template>
      	    </el-form-item>
            <el-form-item label="分享标题" label-width="100" size="small" style="width:100%;">
                <template>
                  {{showoffersinfos.sharetitle}}
                </template>
     	      </el-form-item>
            <el-form-item label="分享内容" label-width="100" style="width:100%;">
                <template>
                  {{showoffersinfos.sharecontent}}
                </template>
      	    </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 分享设置 end-->

           
  </div>
  </transition>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import  QrcodeVue  from 'qrcode.vue'

export default {
  components: {
    quillEditor,
    QrcodeVue,
  },
  data () {
    return {
        url:this.GLOBAL.domain+"Offers/index",
        transitionshow:true,
        actionauth:'', //功能权限
        isselect:false,
        listLoading:false,
        query: {
          act:'getofferscutlists',
	        token:this.$cookies.get('token'),
          date:[],
          status:'',
          minprice:'',
          maxprice:'',
          p:1,
          keytype:1,
          key:'',
          rollpage:10
        },
        datalists:[],
        stattotals:{
          orders:0,
          shops:0,
          users:0,
          amounts:0,
          costs:0
        },
        total_rows:100,
        statuslists:[
          {id:1,name:'未开始'},
          {id:2,name:'进行中'},
          {id:3,name:'已结束'},
        ],
        keytypelists:[
          {id:1,name:'按活动名称搜索关键字'},
          {id:2,name:'按商品名称/sku搜索关键字'},
        ],

        iswarningclose:true,
        addactiveDialog:false,
        addActivequery: {
          act:'addofferscut',
          token:this.$cookies.get('token'),
          id:'',
          name:'',
          thumb:[],
          limitpercent:'',
          content:'',
          share:{
            img:'',
            title:'',
            content:'',
          },
          date:[],
          money:0,
          goods:[],
        },
        addActivequeryloading:false,
        addoffersnewLoading:false,
        addcontentDialog:false,
        goodsDialog:false,
        goodsqueryischange:false,
        isjdshow:false,
        saleagents:[],
        datafrom:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
        groundings:[
          {id:1,name:'未上架'},
          {id:2,name:'已上架'}
        ],
        brandlists:[],
        goodsquery: {
          act:'getoffersgoods',
          token:this.$cookies.get('token'),
          propertyids:'',
          parentagentid:'',
          type:'',
          brandid:'',
          isgrounding:'',
          key:'',
          p:1,
          rollpage:10,
        },
        goodslistsloading:false,
        goodslists:[],
        goods_rows:0,
        selectpropertyids:[],
        selectgoods:[],
        propertyDialog:false,
        propertyloading:false,
        propertyquery: {
          act:'getgoodsproperty',
          token:this.$cookies.get('token'),
          index:'',
          goodsid:''
        },
        propertylists:[],
        showoffersDialog:false,
        showoffersloaing:false,
        showoffersinfos:'',
        offersnewDialog:false,
        offersgoodsstatDialog:false,
        offersgoodsstatloading:false,
        offersnewsgoods:[],
        showgoodsordersDialog:false,
        showgoodsordersloading:false,
        showgoodsorderslists:[],
        showgoodsordersquery: {
          act:'getofferscutorders',
          token:this.$cookies.get('token'),
          id:'',
          goodstype:'',
          p:1,
          rollpage:10
        },
        showgoodsorders_row:0,
        addshareDialog:false,
        sharedetailnewDialog:false,
        shareimg:'',
        sharetitle:'',
        sharecontent:'',
        
        editorOption: { //文本框功能配置
		        placeholder: '请输入内容',
		        modules: { // 配置富文本
			        toolbar: {
				        container: [
					        ['bold', 'italic', 'underline', 'strike'],
                  ['blockquote', 'code-block'],
                  [{ 'header': 1 }, { 'header': 2 }],
                  [{ 'direction': 'rtl' }],
                  [{ 'size': ['small', false, 'large', 'huge'] }],
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'font': [] }],
                  //['image']
				        ],
                handlers: {
                  'image': function(value) {
                      if(value) {
                          document.querySelector('.addoffersfile').click();
                      }else {
                          this.quill.format('image', false);
                      }
                  }
                },
			        },
		        }
	      },
        
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getList(); //获取活动信息
    this.getagents(); //获取代理商信息列表
    this.getBrand(); //获取商品品牌信息
  },
  
  methods:{
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },


    /** 获取活动信息 **/
    getList() {
      if(this.isselect) {
        this.query.p=1;
        this.query.rollpage=10;
      }

      this.listLoading=true;
      var resource = this.$resource(this.url);
	    resource.save(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
            this.listLoading = false;
		    }else{
		        this.datalists = JSON.parse(Base64.decode(res.data.Data));
            this.total_rows=parseInt(res.data.count);
            this.listLoading = false;
            if(this.isselect) this.isselect=false;
            this.getstattotals();
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
          this.listLoading = false;
	    });
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },

    /** 统计商品小计信息 **/
    getstattotals() {
        this.stattotals.orders=0;
        this.stattotals.shops=0;
        this.stattotals.users=0;
        this.stattotals.amounts=0;
        this.stattotals.costs=0;
        let statquery={
          act:'getofferscutstats',
          token:this.query.token,
          date:this.query.date,
          status:this.query.status,
          minprice:this.query.minprice,
          maxprice:this.query.maxprice,
          keytype:this.query.keytype,
          key:this.query.key
        };

        var resource = this.$resource(this.url);
        resource.save(statquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.stattotals.orders=result.orders;
              this.stattotals.shops=result.shops;
              this.stattotals.users=result.users;
              this.stattotals.amounts=result.amounts;
              this.stattotals.costs=result.costs;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    //删除活动信息
    deloffersnew(item) {
      this.$confirm('您是否确定要删除该活动？', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save({act:'delofferscut',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.getList();
            }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      }).catch(() => {
            
      });    
    },

    //获取活动详情信息
    showactives(item) {
      this.showoffersDialog=true;
      this.showoffersloaing=true;
      this.showoffersinfos='';

      var resource = this.$resource(this.url);
      resource.save({act:'getofferscustinfo',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.showoffersloaing=false;
          }else{
              this.showoffersinfos=JSON.parse(Base64.decode(res.data.Data));
              this.showoffersloaing=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.showoffersloaing=false;
      });
    },


    //基础信息
    ///////////////////////////////////////////////////
    //获取代理商列表
    getagents() {
      var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	    resource.query({act:'getsaleagents',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        this.saleagents = JSON.parse(Base64.decode(res.data.Data));
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
    },

    //获取代理商是否有京东商品权限
    getJDshow() {
		  var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	    resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.isjdshow=result.show;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	  },

    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:1000000}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    //////////////////////////////////////////////////

  
  	/** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
      this.actionauth=data;
    },

    /** 关闭提示 **/
    closenotice() {
      this.iswarningclose=false;
    },

    /** 添加活动 **/
    addoffers() {
      this.addActivequery.act='addofferscut';
      this.addActivequery.id='';
      this.addActivequery.name='';
      this.addActivequery.thumb=[];
      this.addActivequery.content='';
      this.addActivequery.share.img='';
      this.addActivequery.share.title='';
      this.addActivequery.share.content='';
      this.addActivequery.date=[];
      this.addActivequery.money=0;
      this.addActivequery.limitpercent='';
      this.addActivequery.goods=[];
      this.addactiveDialog=true;
    },

    /** 关闭添加活动窗口信息前 **/
    closeadd() {
      this.$confirm('温馨提示：关闭当前活动添加/编辑页会导致已填写的数据丢失，您是否确定要关闭？', { type: 'warning' }).then(() => {
         this.addactiveDialog=false;
      }).catch(() => {
         this.addactiveDialog=true;
      });   
    },

    /** 打开/关闭是否限购按钮 **/
    changeaddoffersnew(val,index) {
      if(!val) this.addActivequery.goods[index].limitnums=0;
    },

    /** 删除已选中的商品信息 **/
    deladdoffersgoods(index) {
      this.$delete(this.addActivequery.goods,index);
    },

    /** 删除全部已选的商品信息 **/
    deladdoffersall() {
      this.$confirm('您是否确定要清空已选的商品？', { type: 'warning' }).then(() => {
          this.addActivequery.goods=[];
      }).catch(() => {
            
      });    	
    },

    /** 提取图片信息 **/
    getaddimg(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    }else {
            data.imgsrc=this.GLOBAL.staticUrl+data.imgsrc;
            let quill = this.$refs.myQuillEditor.quill;
            // 获取光标所在位置
			      let length = quill.getSelection().index;
			      // 插入图片  res.info为服务器返回的图片地址
			      quill.insertEmbed(length, 'image', data.imgsrc)
			      // 调整光标到最后
			      quill.setSelection(length + 1);
            obj.target.value = '';  
	        }
	    }).catch((res) => {
	        
	    });
      document.querySelector('.addoffersfile').val=null;
    },


    ///////////////////////////////////////////////////////////////////////////////////////
    //获取商品信息
    checkgoods() {
      let _this=this;
      this.goodsDialog=true;
      this.goodsquery.propertyids='';
      this.goodsquery.parentagentid='';
      this.goodsquery.type='';
      this.goodsquery.brandid='';
      this.goodsquery.isgrounding='';
      this.goodsquery.key='';
      this.goodsquery.p=1;
      this.goodsquery.rollpage=10;
      this.selectpropertyids=[];
      this.selectgoods=[];
      this.addActivequery.goods.forEach(function(item,i) {_this.selectgoods.push(item)});
      
      //剥离信息提取规格id
      for(var i=0;i<this.addActivequery.goods.length;i++) {
        this.selectpropertyids.indexOf(this.addActivequery.goods[i].propertyid)==-1 ? 
        this.selectpropertyids.push(this.addActivequery.goods[i].propertyid) : '';
      }
      this.getgoodsList();
    },

    //获取商品信息
    getgoodsList() {
      this.goodslistsloading=true;
      if(this.goodsqueryischange==true) {
        this.goodsquery.p=1;
        this.goodsquery.rollpage=10;
      }
      var resource = this.$resource(this.url);
      resource.save(this.goodsquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.goodslistsloading = false;
        }else{
          this.goodslists = JSON.parse(Base64.decode(res.data.Data));
          this.goods_rows=parseInt(res.data.count);
          this.goodslistsloading = false;
          if(this.goodsqueryischange==true) this.goodsqueryischange=false;
          //勾选已选中的商品信息
          let _this=this;
          setTimeout(function() {
              for(var i=0;i<_this.goodslists.length;i++) {
                  if(_this.selectpropertyids.indexOf(_this.goodslists[i].propertyid) >=0) 
                  _this.$refs.multipleTable.toggleRowSelection(_this.goodslists[i]);
              }
          },200);
          
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.goodslistsloading=false;
      });
    },

    pageChoosegoodsChange(val) {
        this.goodsquery.rollpage = val;
        this.getgoodsList();
    },
    pageChoosegoodsCurrentChange(val) {
        this.goodsquery.p = val;
        this.getgoodsList();
    },

    //点击单行选择商品信息
    rowclick(val,row) {
        var index=0;
        for(var i=0;i<this.goodslists.length;i++) {
          if(val.propertyid==this.goodslists[i].propertyid) index=i;
        }
        //勾选、取消勾选当前行
        this.$refs.multipleTable.toggleRowSelection(this.goodslists[index]);
        index=this.selectpropertyids.indexOf(val.propertyid);
        if(index==-1) {
            this.selectpropertyids.push(val.propertyid);
            this.selectgoods.push({goodsid:val.goodsid,name:val.name,propertyid:val.propertyid,spec:val.spec,islimit:0,limitnums:1,allnums:0,type:val.type==0 ? 1 : 2,agentname:val.agentname,price:val.price,sendnums:0,weight:val.weight});
        }else {
            this.$delete(this.selectpropertyids,index);
            this.$delete(this.selectgoods,index);
        }
    },

    //点击勾选信息
    handleSelectsingle(val,row) {
        var index=0;
        index=this.selectpropertyids.indexOf(row.propertyid);
        if(index==-1) {
            this.selectpropertyids.push(row.propertyid);
            this.selectgoods.push({goodsid:row.goodsid,name:row.name,propertyid:row.propertyid,spec:row.spec,islimit:0,limitnums:1,allnums:0,type:row.type==0 ? 1 : 2,agentname:row.agentname,price:row.price,sendnums:0,weight:val.weight});
        }else {
            this.$delete(this.selectpropertyids,index);
            this.$delete(this.selectgoods,index);
        }
    },

    //点击全选商品信息
    handleSelectall(val) {
        let _this=this;
        let index=0;
        this.goodslists.forEach(function(item,i) {
            if(val.length > 0) {
                _this.selectgoods.push({goodsid:item.goodsid,name:item.name,propertyid:item.propertyid,spec:item.spec,islimit:0,limitnums:1,allnums:0,type:item.type==0 ? 1 : 2,agentname:item.agentname,price:row.price,sendnums:0,weight:val.weight});
            }else {
                index=_this.selectpropertyids.indexOf(item.propertyid);
                _this.$delete(_this.selectpropertyids,index);
                _this.$delete(_this.selectgoods,index);
            }
            /**
            index=_this.selectpropertyids.indexOf(item.propertyid);
            if(index==-1) {
                _this.selectgoods.push({goodsid:item.goodsid,name:item.name,propertyid:item.propertyid,spec:item.spec,islimit:0,limitnums:1,allnums:0,type:item.type==0 ? 1 : 2,agentname:item.agentname,price:row.price,sendnums:0});
            }else {
                _this.$delete(_this.selectpropertyids,index);
                _this.$delete(_this.selectgoods,index);
            }
            */
        });
    },

    //修改商品规格信息
    changeproperty(item,index) {
      this.propertylists=[];
      this.propertyquery.index=index;
      this.propertyquery.goodsid=item.goodsid;
      this.propertyDialog=true;
      this.propertyloading=true;

      var resource = this.$resource(this.url);
      resource.save(this.propertyquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.propertyloading = false;
        }else{
          this.propertylists = JSON.parse(Base64.decode(res.data.Data));
          this.propertyloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.propertyloading=false;
      });
    },

    //确认选择商品规格信息
    selectpropertys(item) {
      let index=this.propertyquery.index;
      let _this=this;
      let istrue=false;

      if(this.addActivequery.goods[index].propertyid==item.id) { //规格已存在的无需处理
          this.propertyDialog=false;
      }else {
          _this.addActivequery.goods.forEach(function(t,i) {
              if(i!=index && t.propertyid==item.id) istrue=true;
          });
          if(istrue) { //商品规格已存在，抛出错误，不允许添加
              this.$message.error("该规格信息已被添加到商品列表中");
          }else { //商品规格信息不存在，正常修改
              this.addActivequery.goods[index].propertyid=item.id;
              this.addActivequery.goods[index].spec=item.spec;
              this.addActivequery.goods[index].weight=item.weight;
              this.addActivequery.goods[index].type=item.type==0 ? 1 : 2;
              this.addActivequery.goods[index].agentname=item.agentname;
              this.propertyDialog=false;
          }
      }

    },

    //添加已选中的商品信息
    addgoodssave() {
      //剔除旧数据
      let _this=this;
      let propertyids=[];
      let lastpropertyids=[];
      let data=[];

      this.selectgoods.forEach(function(t,i) {
        propertyids.push(t.propertyid);
      });
      this.addActivequery.goods.forEach(function(item,i) {
        if(propertyids.indexOf(item.propertyid) >=0) {data.push(item);lastpropertyids.push(item.propertyid);}
      });
      this.selectgoods.forEach(function(t,i) {
        lastpropertyids.indexOf(t.propertyid)==-1 ? data.push(t) : '';
      });

      this.addActivequery.goods=data;
      this.goodsDialog=false;
    },

    //保存活动信息
    addcreateSave() {
      let offersotherquery={act:this.addActivequery.act,token:this.addActivequery.token,id:this.addActivequery.id,name:this.addActivequery.name,thumb:this.addActivequery.thumb,content:this.addActivequery.content,date:this.addActivequery.date,money:this.addActivequery.money,goods:[],share:this.addActivequery.share,limitpercent:this.addActivequery.limitpercent};
      this.addActivequery.goods.forEach(function(item,i) {
        offersotherquery.goods.push({propertyid:item.propertyid,goodsid:item.goodsid,islimit:item.islimit,limitnums:item.limitnums,allnums:item.allnums,sendnums:item.sendnums,price:item.price});
      });

      this.addoffersnewLoading=true;
      var resource = this.$resource(this.url);
      resource.save(offersotherquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addoffersnewLoading = false;
        }else{
          this.addoffersnewLoading = false;
          this.addactiveDialog=false;
          this.getList();
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addoffersnewLoading=false;
      });
    },
    ////////////////////////////////////////////////////////////////////////////////////////

    //获取商品下单信息统计
    getorderstats(obj) {
      this.offersgoodsstatDialog=true;
      this.offersgoodsstatloading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'getcutorderstat',token:this.$cookies.get('token'),id:obj.id}).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.offersgoodsstatloading = false;
        }else{
          this.offersnewsgoods = JSON.parse(Base64.decode(res.data.Data));
          this.offersgoodsstatloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.offersgoodsstatloading=false;
      });
    },

    //获取活动商品所下订单数据信息
    showgoodsorders(item) {
      this.showgoodsordersDialog=true;
      this.showgoodsordersquery.p=1;
      this.showgoodsordersquery.rollpage=10;
      this.showgoodsordersquery.id=item.id;
      this.showgoodsordersquery.goodstype=item.goodstype;
      this.getshowgoodsorders();
    },

    //获取订单详情数据
    getshowgoodsorders() {
      this.showgoodsordersloading=true;
      var resource = this.$resource(this.url);
      resource.save(this.showgoodsordersquery).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.showgoodsordersloading = false;
        }else{
          this.showgoodsorderslists = JSON.parse(Base64.decode(res.data.Data));
          this.showgoodsorders_row=parseInt(res.data.count);
          this.showgoodsordersloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.showgoodsordersloading=false;
      });
    },

    pageoffersordersChange(val) {
        this.showgoodsordersquery.rollpage = val;
        this.getshowgoodsorders();
    },
    pageoffersordersCurrentChange(val) {
        this.showgoodsordersquery.p = val;
        this.getshowgoodsorders();
    },

    /** 获取编辑活动信息 **/
    editoffersnew(item) {
      this.addactiveDialog=true;
      this.addActivequeryloading=true;

      var resource = this.$resource(this.url);
      resource.save({act:'geteditofferscut',token:this.$cookies.get('token'),id:item.id}).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addActivequeryloading = false;
        }else{
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.addActivequery.act='editofferscut';
          this.addActivequery.id=item.id;
          this.addActivequery.name=result.name;
          this.addActivequery.thumb=[];
          this.addActivequery.thumb=result.thumb;
          this.addActivequery.content=result.content;
          this.addActivequery.date=result.date;
          this.addActivequery.money=result.money;
          this.addActivequery.limitpercent=result.limitpercent;
          this.addActivequery.goods=result.goods;
          this.addActivequery.share.img=result.shareimg;
          this.addActivequery.share.title=result.sharetitle;
          this.addActivequery.share.content=result.sharecontent;
          this.addActivequeryloading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addActivequeryloading=false;
      });
    },


    /** 点击上传活动图片信息 **/
    getadimga() {
        //if(this.addActivequery.thumb.length==4) {this.$message.error("活动最多只能上传4张宣传图片");return false;}
        document.getElementById('adimg').click();
    },

    //上传图片
    getadimgb(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	  this.$message.error(data.msg);
		    }else {
            this.addActivequery.thumb.push(data.imgsrc);
            obj.target.value = '';  
	      }

	    }).catch((res) => {
	        
	    });
    },

	  //删除图片
	  closethumb(index) {
		    this.$delete(this.addActivequery.thumb,index);
	  },



    /*** 设置分享内容 ***/
    getsharecontent() {
      document.getElementById('shareimg').click();
    },
    getshareaddimg(obj) {
      var file=obj.target.files[0]; //获取文件信息
    	var formData = new FormData();
    	formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    }else {
            this.addActivequery.share.img=data.imgsrc;
            obj.target.value = '';  
	        }
	    }).catch((res) => {
	        
	    });
    },
    /*** 设置分享内容 **/

  }
}
</script>
<style>
.backborder1s {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder2s {background:rgba(211, 211, 211, 0.6);border-radius:5px;border:1px solid #ddd;min-height:70px;overflow:hidden;transition:.36s all}
.backborder2s .content {float:left;width:95%;font-size:12px;}
.backborder2s .content ul {margin:0;padding:0}
.backborder2s .content li {float:left;width:100%;list-style-type:none;line-height:18px;color:red;margin-top:5px}
.backborder2s .close {float:right;width:5%}
.backborder2s .close .el-button--mini.is-circle {padding:5px;margin-top:50px}
.closenotice {display:none}
.backbbtn .el-button--mini.is-circle {margin:0}

.activetotal {float:left;margin-right:3%;color:#8b572a;font-size:13px;font-weight:550}
.offermoney i {float:left;font-style:normal;font-size:12px;margin-right:5px;background:#E6A23C;color:#fff;padding:5px 10px;line-height:12px;border-radius:15px;margin-top:5px}
.offermoney span {float:left;font-size:12px;margin-top:5px;color:#8b572a;font-weight:600}
.offertime i {float:left;font-style:normal;font-size:12px;margin-right:5px;background:#409EFF;color:#fff;padding:5px 10px;line-height:12px;border-radius:15px;margin-top:5px}
.offertime span {float:left;font-size:12px;margin-top:5px;color:#666}
.offertitles span {float:left;margin-right:10px;max-width:70%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.offerstatus1 {float:left;font-style:normal;font-size:10px;background:rgba(144,147,153,.1);border-color:rgba(144,147,153,.2);border:1px solid;color:#909399;border-radius:15px;padding:3px;line-height:10px;margin-top:3px}
.offerstatus2 {float:left;font-style:normal;font-size:10px;background:rgba(103,194,58,.1);border-color:rgba(103,194,58,.2);border:1px solid;color:#67c23a;border-radius:15px;padding:3px;line-height:10px;margin-top:3px}

.addoffersnew .el-form-item {margin-bottom:12px}

.offersnewgoods {float:left;width:90%;padding:0 5%;margin:20px 0 60px 0}
.offersgoodsshow {float:left;width:100%;border-bottom:1px dashed #ddd;line-height:14px}
.offersnewgoods p {float:left;font-size:14px;font-weight:bold;}
.showoffersgoods {float:left;width:100%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap}
.showoffersgoodsspec {float:left;margin-top:5px;width:100%;font-size:12px;color:#999999;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.showoffersgoodsspec a {float:left;padding:5px 2px;line-height:12px;border:1px dashed #999999;border-radius:5px;cursor:pointer}
.showoffersgoodsspec a:hover {background:rgb(255,209,0,.6);border-color:rgb(255,209,0,.9);color:#333336}
.showoffersgoodsagent {float:left;margin-right:10px;font-size:12px;line-height:12px;background:#e6a23c;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}
.showoffersgoodscz {float:left;font-size:12px;line-height:12px;background:#67c23a;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}
.showoffersgoodsjd {float:left;font-size:12px;line-height:12px;background:#f56c6c;color:#fff;font-style:normal;padding:5px 5px;border-radius:15px;margin-top:10px}


.offersnewgoods {float:left;width:100%;padding:10px;}
.offersallsetting {float:left;margin-left:2%;line-height:13px}
.offersallsetting p {float:left;font-size:13px;color:#8b572a;line-height:14px;margin-top:7px;padding:5px}
.offersallsetting p em {font-style:normal;font-size:15px;font-weight:bold}
.offersnewct img {float:left;max-width:100%}

.backborder-other {background:#fff;float:left;width:98%;padding:0 1%;}
.backborder-other .imglists {float:left;width:100%;padding:0;margin:0 0 10px 0}
.backborder-other .imglists li {float:left;height:70px;padding:1px;border-radius:5px;border:1px solid #dddddd;margin:0 1% 20px 0;list-style-type:none;padding:2px;border-radius:5px}
.backborder-other .imglists li a {cursor:pointer}
.backborder-other .imglists li img {float:left;height:70px;border-radius:5px}
.backborder-other .thumbclose {color:#fff;font-weight:bold;padding:5px;border-radius:50%;background:#F56C6C;padding:8px 5px;font-size:14px;line-height:2px;position:absolute;margin:-1px 0 0 -10px}

</style>


// WEBPACK FOOTER //
// src/components/mall/Offerscut.vue